import React from "react";

const Halt = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill || "#640D5F"}
            d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2s16 7.163 16 16Z"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.607}
            d="M13.79 18h8.42m-8.42-5.894v11.79m8.42-11.79v11.79m-1.684 0h3.369m-3.369-11.79h3.369m-11.79 11.79h3.369m-3.369-11.79h3.369"
        />
    </svg>
);

export default Halt
